import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Fall from '../../component/Fall/Main_Fall';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';

const KimJiMin = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "정현민 ♥ 김지민 결혼합니다";
    const openDesc = "11월 01일 토요일 오전 10시 30분\n부천 MJ컨벤션 3층 다이너스티홀";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/253/thumb.jpg";
    
    // const parents = [
    //     {groom : "박삼용의 아들"},
    //     {bride : "최재선 · 김연순의 손녀"}
    // ] 

    const placeTelNum = "032-347-5500";

    const lng = 126.79853505353;
    const lat = 37.481504867692;

    const forCar = "네비게이션 입력 - 부천시 소사구 소사본동 65-7번지\n서울외곽순환고속도로(시흥IC) - 소사본3동 - 소사구청 옆";
    const forBus = "소사어울마당삼거리 · MJ 컨벤션 : 19, 83, 88, 88-1\n소사어울마당 삼거리 : 53, 60-1\n소사역 · 소사지구대 : 19, 53, 83, 88\n소사 푸르지오 : 56, 56-1, 60";
    const forSubway = "1호선, 서해선 > 소사역 1번출구 건너편 좌측(70m)";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "FALL",
        titleColor: "#000000",
        pointColor: "#AB5934",
        btnBgColor: "#AB5934",
        fontColor: "#000000",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }

    const title = "소중한 분들을 초대합니다"

    const msg1 = "무더운 여름날, 찾아온 행복\n훈훈함이 가득했던 사계절\n그렇게 스물아홉번의 계절을 지나\n서로에게 평생의 온정이 되어주자 합니다";
    const msg2 = "저희의 찬란한 시작을 위해\n함께 자리를 빛내주시면 감사하겠습니다.";
    const msg3 = "현민 . 지민 올림";

    const groomAccountList = [
        {
            role: "신랑",
            name: "정현민",
            bank: "국민은행",
            accountNumber : "259202-04-284026",
            isKakao : true,
            kakakoUrl : "https://qr.kakaopay.com/FDpgIVjWn"
        }
        ,{
            role: "신랑 부",
            name: "정낙승",
            bank: "국민은행",
            accountNumber : "024801-04-266847",
            isKakao : false
        },
        {
            role: "신랑 모",
            name: "홍수정",
            bank: "국민은행",
            accountNumber : "643901-01-295618",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "김지민",
            bank: "카카오뱅크",
            accountNumber : "3333-04-6122678",
            isKakao : true,
            kakaoUrl: "https://qr.kakaopay.com/Ej8hF4DLJ"
        }
        ,{
            role: "신부 부",
            name: "김영훈",
            bank: "기업은행",
            accountNumber : "626-048074-01-011",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "백경운",
            bank: "농협은행",
            accountNumber : "217019-56-029830",
            isKakao : false
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "최지현",
            call: "010-3916-8214"
        }
        // ,{
        //     role: "신부 부",
        //     name: "고제근",
        //     call: "010-5486-2180"
        // },
        // {
        //     role: "신부 모",
        //     name: "김영자",
        //     call: "010-4211-7796"
        // }
    ]


    const groomCallInfoList = [
        {
            role: "신랑",
            name: "박범진",
            call: "010-6261-8292"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "박홍숙",
        //     call: "010-6361-4000"
        // },
        // {
        //     role: "신랑 모",
        //     name: "안은미",
        //     call: "010-6456-4307"
        // }
    ]

    const parentInfo = {
        groom: {
            dad: { name: "박삼용", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장남",
        },
        bride: {
            dad: { name: "최명성", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장녀",
        }
    };


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // Park Seo Young -> Park Seo young
    const toLowerCaseString = (str) => {
        const parts = str.split(" ");
        if (parts.length < 2) return str; // 성과 이름이 없으면 그대로 반환

        // 첫 단어(성)는 그대로 유지
        const firstPart = parts[0];

        // 두 번째 단어 이후로 처리
        const restParts = parts.slice(1).map((part, index) =>
            index === 0
                ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() // 첫 단어만 첫 글자 대문자
                : part.toLowerCase() // 나머지는 소문자로 변환
        );

        return `${firstPart} ${restParts.join(" ")}`;
    };
    

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Fall brideNameEn={getFirstNameEn(weddingData.groomNameEn)} groomNameEn={getFirstNameEn(weddingData.brideNameEn)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.pointColor} />
                    <Info_Fall weddingData={weddingData} conceptStyle={conceptStyle} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    {/* <CallInfo marginTop={"20px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"auto"} hotoHeight={"235px"} gap={"4px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default KimJiMin;